import { flexRender, Table } from '@tanstack/react-table';
import { ReactElement } from 'react';

import { $FooterTr, $StyledTFoot, $StyledTFootTd } from './DatatableCore.styles';

interface TableFooterProps<D> {
  table: Table<D>;
  dataTestId?: string;
}

const Footer = <D = unknown,>({
  table,
  dataTestId,
}: TableFooterProps<D>): ReactElement => {
  'use no memo';

  return (
    <$StyledTFoot>
      {table.getFooterGroups().map((footerGroup) => {
        return (
          <$FooterTr key={footerGroup.id}>
            {footerGroup.headers.map((header, cellIndex) => {
              return (
                <$StyledTFootTd
                  key={header.id}
                  colSpan={header.colSpan}
                  $size={header.column.getSize()}
                  $minSize={header.column.columnDef.minSize}
                  $maxSize={header.column.columnDef.maxSize}
                  data-testid={
                    dataTestId ? `footer_${dataTestId}_${cellIndex}` : undefined
                  }
                >
                  {flexRender(
                    header.column.columnDef.footer,
                    header.getContext(),
                  )}
                </$StyledTFootTd>
              );
            })}
          </$FooterTr>
        );
      })}
    </$StyledTFoot>
  );
};

export default Footer;
